import React from 'react'

const QuickDrag = ({ style = {}, ...props }) => {
  return (
    <svg
      width="32"
      height="29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}>
      <path
        d="M.286 5.99C.573 3.093 2.746.854 5.63.455A46.921 46.921 0 0 1 12 0c2.36 0 4.564.206 6.371.456 2.882.4 5.056 2.638 5.343 5.533C23.875 7.621 24 9.644 24 12c0 2.356-.125 4.38-.287 6.01-.286 2.896-2.46 5.134-5.342 5.534A46.92 46.92 0 0 1 12 24a46.92 46.92 0 0 1-6.371-.456c-2.882-.4-5.056-2.638-5.343-5.533A61.167 61.167 0 0 1 0 12c0-2.356.125-4.38.286-6.01z"
        fill="#16A5F3"
        fillOpacity=".07"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.286 5.99a6.29 6.29 0 0 1 .536-1.997l1.819.83a4.29 4.29 0 0 0-.364 1.364c-.045.45-.087.932-.124 1.445L.16 7.49c.038-.531.081-1.032.127-1.5zm1.73 4.551l-1.999-.046a65.607 65.607 0 0 0 0 3.01l2-.046a63.587 63.587 0 0 1 0-2.918zm.137 5.827L.16 16.51c.038.531.081 1.032.127 1.5a6.29 6.29 0 0 0 .536 1.996l1.819-.83a4.29 4.29 0 0 1-.364-1.363 52.866 52.866 0 0 1-.124-1.446zm2.394 4.778l-.894 1.79a6.37 6.37 0 0 0 1.976.608c.5.069 1.03.135 1.586.194l.211-1.989a48.5 48.5 0 0 1-1.523-.186 4.367 4.367 0 0 1-1.356-.417zm5.93.825l-.075 1.998a42.43 42.43 0 0 0 3.196 0l-.076-1.998a40.228 40.228 0 0 1-3.044 0zm11.37-14.339l1.994-.143a55.707 55.707 0 0 0-.128-1.5 6.29 6.29 0 0 0-.535-1.996l-1.819.83c.189.414.315.871.364 1.364.045.45.087.932.124 1.445zm-2.394-4.778l.894-1.79A6.369 6.369 0 0 0 18.37.457c-.5-.069-1.03-.135-1.586-.194l-.211 1.989c.533.057 1.042.12 1.523.186a4.37 4.37 0 0 1 1.356.417zm-5.93-.825l.075-1.998a42.267 42.267 0 0 0-3.196 0l.076 1.998a40.27 40.27 0 0 1 3.044 0zM5.628.456c.5-.069 1.03-.135 1.586-.194l.211 1.989a51.47 51.47 0 0 0-1.523.186 4.37 4.37 0 0 0-1.356.417l-.894-1.79A6.37 6.37 0 0 1 5.63.457z"
        fill="#16A5F3"
      />
      <path
        d="M30.324 15.125L11.55 7.904a.5.5 0 0 0-.646.646l7.22 18.774a.5.5 0 0 0 .942-.021l2.809-8.428 8.428-2.81a.5.5 0 0 0 .021-.94z"
        fill="#16A5F3"
      />
    </svg>
  )
}

export default QuickDrag
